import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { useSmallScreen } from '../../helpers/customHooks';

import { Stack, TruncatedText, Typography } from '@/mui/components';

import styles from './VideoInfo.module.scss';

function VideoInfo({ description = '', rows = 3, ...props }) {
  const isSmallScreen = useSmallScreen();
  const typographyVariant = !isSmallScreen ? 'body2' : 'caption';

  return (
    <div className={classNames(styles.Info, { [styles.Info___hovered]: props.isHovered })}>
      <Stack spacing={!isSmallScreen ? 5 : 3} className={styles.InfoContainer}>
        {description && (
          <Typography variant={typographyVariant} data-a="video-description">
            <TruncatedText title={description} rows={rows}>
              {description}
            </TruncatedText>
          </Typography>
        )}
        <Stack spacing={0} justifyContent="space-between" direction="row" alignItems="center">
          <Typography variant={typographyVariant} component="div" color="inherit" data-a="video-date-time">
            {props.date}
          </Typography>
          <Typography
            data-a="video-duration"
            variant={typographyVariant}
            className={styles.InfoMetaTime}
            component="div"
            color="inherit"
          >
            {props.duration}
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
}

VideoInfo.propTypes = {
  description: PropTypes.string,
  date: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  isHovered: PropTypes.bool.isRequired,
  rows: PropTypes.number,
};

export default VideoInfo;
